import DataSource from "src/core/data-sources/dataSource";
import EventBus from "src/core/common/eventBus";
import * as AccountsApi from "../../api/accounts";

class DocumentsDataSource extends DataSource {
  doGet({hasDocument, documentType}) {
    if (!hasDocument) return Promise.resolve(null);
    return AccountsApi.getIdentityDocument(documentType);
  }

  getEventBus() {
    return eventBus;
  }
}

const eventBus = new EventBus();

export default DocumentsDataSource;
